import SEO from './composants/SEO';
import { SEO_PAGES } from './donnees/seoPages';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';
import './Accueil.css';
import { useAuth } from './AuthContext';
import { appelAPI } from './api';
import Navigation from './composants/Navigation';
import PiedDePage from './composants/PiedDePage';
// ══════════════════════════════════════════════════════════════
// PEFEP Site — PAGE D'ACCUEIL v2.0
// - Navigation consciente de l'état de connexion
// - Tarifs centralisés en données (source unique de vérité)
// - Sections redynamisées
// ══════════════════════════════════════════════════════════════
// ── CHIFFRES CLÉS ──
const STATS = [
  { icone: '🎯', valeur: '11',   label: 'Secteurs couverts',  detail: 'Questions adaptées à chaque métier' },
  { icone: '⚡', valeur: '30',   suffixe: 'min', label: 'Pour créer votre site', detail: 'Du premier clic à la mise en ligne' },
  { icone: '🤖', valeur: '100',  suffixe: '%',   label: 'Personnalisé par IA',   detail: 'Aucun template générique' },
];
// ── ÉTAPES ──
const ETAPES = [
  {
    num: '1', icone: '📝', titre: 'Répondez aux questions',
    texte: "Notre wizard intelligent vous guide étape par étape. Décrivez votre activité, vos services, vos valeurs — comme si vous parliez à un consultant.",
  },
  {
    num: '2', icone: '🤖', titre: "L'IA génère votre site",
    texte: "Notre intelligence artificielle transforme vos réponses en contenu professionnel, choisit les images parfaites et structure votre site automatiquement.",
  },
  {
    num: '3', icone: '🌐', titre: 'Votre site est en ligne',
    texte: "Après paiement via MonCash, votre site est publié automatiquement. Vous recevez votre lien et l'accès à votre tableau de bord.",
  },
];
// ── AVANTAGES ──
const AVANTAGES = [
  { icone: '⚡',  titre: 'Ultra rapide',            teinte: 'or',    texte: "Votre site est prêt en moins de 30 minutes. Pas de semaines d'attente, pas de va-et-vient interminable." },
  { icone: '🇭🇹', titre: 'Fait pour Haïti',         teinte: 'bleu',  texte: "Questions adaptées au contexte haïtien, paiement MonCash, support en français et créole." },
  { icone: '🤖',  titre: 'Intelligence Artificielle', teinte: 'vert', texte: "Claude AI génère un contenu unique et professionnel basé sur vos vraies informations — pas un template générique." },
  { icone: '💰',  titre: 'Prix accessible',         teinte: 'vert',  texte: "À partir de 49$ pour un site complet. 10x moins cher qu'une agence traditionnelle pour un résultat professionnel." },
  { icone: '📱',  titre: '100% Mobile',             teinte: 'bleu',  texte: "Tous les sites générés sont automatiquement adaptés aux téléphones mobiles — essentiel pour le marché haïtien." },
  { icone: '🔐',  titre: 'Votre espace personnel',  teinte: 'or',    texte: "Accédez à votre tableau de bord pour modifier vos informations, suivre votre site et renouveler votre hébergement." },
];
// ── SECTEURS ──
const SECTEURS = [
  { icone: '⛪',  label: 'Église / Ministère' },
  { icone: '🍽️', label: 'Restaurant' },
  { icone: '🤝',  label: 'ONG / Association' },
  { icone: '🎯',  label: 'Coach / Formateur' },
  { icone: '🛍️', label: 'Boutique E-commerce' },
  { icone: '🎓',  label: 'École / Formation' },
  { icone: '💅',  label: 'Salon de Beauté' },
  { icone: '✍️',  label: 'Blog / Média' },
  { icone: '🏠',  label: 'Immobilier' },
  { icone: '💼',  label: 'Freelancer' },
  { icone: '⚕️',  label: 'Profession Libérale' },
];
// ══════════════════════════════════════════════════════════════
// TARIFS — SOURCE UNIQUE DE VÉRITÉ
// Pour changer un prix ou une offre, modifier UNIQUEMENT ici.
// ══════════════════════════════════════════════════════════════
const TARIFS_CLIENT = {
  icone: '👤',
  titre: 'Client Simple',
  sousTitre: 'Paiement unique — Idéal pour les entrepreneurs, ONG, églises et organisations',
  offres: [
    {
      nom: 'Basique', prix: '6 600', unite: 'HTG', equivalent: '≈ 49 $ US', type: 'Paiement unique', cta: 'Commencer',
      avantages: [
        'Site complet généré par IA',
        'Sous-domaine PEFEP inclus',
        'Hébergement 1 an inclus',
        'Accès tableau de bord',
        "Vidéo d'orientation",
      ],
    },
    {
      nom: 'Complet', prix: '10 600', unite: 'HTG', equivalent: '≈ 79 $ US', type: 'Paiement unique', cta: 'Commencer',
      vedette: true, badge: 'Le plus populaire',
      avantages: [
        'Tout le plan Basique',
        'Domaine .com personnalisé',
        'SEO de base optimisé',
        'Formulaire de contact actif',
        'Support WhatsApp 7 jours',
      ],
    },
    {
      nom: 'Renouvellement', prix: '6 750', unite: 'HTG/an', equivalent: '≈ 50 $ US', type: 'Hébergement', cta: 'Renouveler',
      avantages: [
        'Renouvellement hébergement',
        'Renouvellement domaine',
        'Site maintenu en ligne',
        'Sauvegarde incluse',
        'Support technique',
      ],
    },
  ],
};
const HOSTINGER_AFFILIE = 'https://www.hostinger.com/fr?REFERRALCODE=KPDISAACPJMG';
const TARIFS_DEV = {
  icone: '💻',
  titre: 'Développeur / Agence',
  sousTitre: 'Payez au projet, pas à l\'abonnement — conçu pour la réalité du marché haïtien',
  offres: [
    {
      nom: 'Essai', prix: '0', unite: 'HTG', equivalent: 'Gratuit', type: 'Sans engagement', cta: 'Créer mon compte',
      avantages: [
        '3 sites d\'essai offerts',
        'Toutes les fonctionnalités',
        'Dashboard développeur',
        'Aperçu complet avant paiement',
        'Sites non publiables',
      ],
    },
    {
      nom: 'À l\'unité', prix: '4 725', unite: 'HTG', equivalent: '≈ 35 $ US le projet', type: 'Paiement au projet', cta: 'Commencer',
      avantages: [
        'Site complet généré par IA',
        'Export HTML autonome',
        'Hébergez où vous voulez',
        'Aucun engagement',
        'Crédit sans expiration',
      ],
    },
    {
      nom: 'Pack 10', prix: '33 750', unite: 'HTG', equivalent: '≈ 250 $ US — 25 $ le projet', type: 'Économisez 100 $', cta: 'Choisir ce pack',
      vedette: true, badge: 'Le plus rentable',
      avantages: [
        '10 projets à utiliser librement',
        'Soit 25 $ par projet',
        'Crédits sans expiration',
        'Support WhatsApp prioritaire',
        'Packs intermédiaires dans votre espace',
      ],
    },
    {
      nom: 'Agency', prix: '13 365', unite: 'HTG/mois', equivalent: '≈ 99 $ US par mois', type: 'Abonnement mensuel', cta: 'Passer à Agency',
      badge: 'Volume', badgeCouleur: '#005AA9',
      avantages: [
        'Projets illimités',
        'Dashboard multi-clients',
        'Accès API complet',
        'Rentable dès 4 projets/mois',
        'Hébergement et domaine non inclus',
      ],
    },
  ],
  surMesure: {
    badge: '✨ Sur mesure',
    nom: 'Business Plus',
    accroche: 'Hébergement + nom de domaine, gérés pour vous',
    texte: "Les forfaits À l'unité, Pack 10 et Agency couvrent la génération des sites — "
      + "pas l'hébergement ni le nom de domaine. Business Plus prend le relais : "
      + "décrivez vos besoins et nous construisons une offre à votre volume.",
    points: [
      'Hébergement géré par PEFEP Site',
      'Nom de domaine .com / .fr / .org inclus',
      'Tarif dégressif selon le nombre de sites',
      'Renouvellement centralisé, une seule facture',
      'Interlocuteur dédié',
    ],
    cta: '📝 Décrire mon besoin',
    ctaAffilie: '🚀 Acheter mon hébergement chez Hostinger',
    lienAffilie: HOSTINGER_AFFILIE,
    mentionAffilie: 'Lien partenaire — vous hébergez vous-même, en toute autonomie.',
  },
};
// ══════════════════════════════════════════════════════════════
// APPARITION AU DÉFILEMENT
// ══════════════════════════════════════════════════════════════
function useRevelation() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const element = ref.current;
    if (!element || typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return;
    }
    const observateur = new IntersectionObserver(
      ([entree]) => {
        if (entree.isIntersecting) {
          setVisible(true);
          observateur.disconnect();
        }
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );
    observateur.observe(element);
    return () => observateur.disconnect();
  }, []);
  return [ref, visible];
}
function Revele({ children, delai = 0, className = '' }) {
  const [ref, visible] = useRevelation();
  return (
    <div
      ref={ref}
      className={`revele ${visible ? 'revele-visible' : ''} ${className}`}
      style={{ transitionDelay: `${delai}ms` }}
    >
      {children}
    </div>
  );
}
// ══════════════════════════════════════════════════════════════
// CARTE TARIF
// ══════════════════════════════════════════════════════════════
// ═════════════════════════════════════════════════════════════
// EN-TÊTE DE SECTION
// ═════════════════════════════════════════════════════════════
function EnTeteSection({ badge, titre, sousTitre, sombre = false }) {
  return (
    <Revele>
      <header className={`entete-section ${sombre ? 'entete-sombre' : ''}`}>
        <div className="section-badge section-badge-xl">{badge}</div>
        <h2 className="section-titre">{titre}</h2>
        {sousTitre && <p className="section-sous-titre">{sousTitre}</p>}
        <span className="entete-trait" />
      </header>
    </Revele>
  );
}
function CarteTarif({ offre, onChoisir }) {
  return (
    <div className={`tarif-card ${offre.vedette ? 'featured' : ''}`}>
      {offre.badge && (
        <div
          className="tarif-badge-top"
          style={offre.badgeCouleur ? { background: offre.badgeCouleur } : undefined}
        >
          {offre.badge}
        </div>
      )}
      <div className="tarif-header">
        <h3>{offre.nom}</h3>
        <div className="tarif-prix">
          {offre.prix} <span>{offre.unite}</span>
        </div>
        {offre.equivalent && <div className="tarif-equivalent">{offre.equivalent}</div>}
        <div className="tarif-type">{offre.type}</div>
      </div>
      <ul className="tarif-liste">
        {offre.avantages.map((a, i) => <li key={i}>✅ {a}</li>)}
      </ul>
      <button
        type="button"
        className={`tarif-btn ${offre.vedette ? 'featured-btn' : ''}`}
        onClick={onChoisir}
      >
        {offre.cta}
      </button>
    </div>
  );
}
// ══════════════════════════════════════════════════════════════
// SEGMENT DE TARIFS
// ══════════════════════════════════════════════════════════════
// ═════════════════════════════════════════════════════════════
// MODALE — DEMANDE D'OFFRE SUR MESURE
// ═════════════════════════════════════════════════════════════
function ModaleBesoin({ onFermer }) {
  const [form, setForm] = useState({
    nom: '', email: '', whatsapp: '', nbSites: '1 à 5', besoin: '',
  });
  const [envoi, setEnvoi] = useState(false);
  const [envoye, setEnvoye] = useState(false);
  const [erreur, setErreur] = useState('');
  const changer = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  // Fermeture avec la touche Échap
  useEffect(() => {
    const surTouche = (e) => { if (e.key === 'Escape') onFermer(); };
    document.addEventListener('keydown', surTouche);
    return () => document.removeEventListener('keydown', surTouche);
  }, [onFermer]);
  const envoyer = async () => {
    if (!form.nom || !form.email || !form.besoin) {
      setErreur('Merci de renseigner votre nom, votre email et votre besoin.');
      return;
    }
    setErreur('');
    setEnvoi(true);
    try {
      await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          access_key: '1a0e5769-fe54-4c9c-a553-91070bf0e9d2',
          subject: '💼 Demande Business Plus — PEFEP Site',
          from_name: 'PEFEP Site',
          name: form.nom,
          email: form.email,
          message:
            `DEMANDE BUSINESS PLUS\n\n` +
            `Nom : ${form.nom}\n` +
            `Email : ${form.email}\n` +
            `WhatsApp : ${form.whatsapp || 'Non fourni'}\n` +
            `Nombre de sites estimé : ${form.nbSites}\n\n` +
            `Besoin :\n${form.besoin}`,
        }),
      });
      setEnvoye(true);
    } catch (err) {
      setErreur('Envoi impossible. Contactez-nous sur WhatsApp au +509 4737 6200.');
    }
    setEnvoi(false);
  };
  return (
    <div className="modale-fond" onClick={onFermer} role="presentation">
      <div
        className="modale-boite"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Demande d'offre Business Plus"
      >
        <button type="button" className="modale-fermer" onClick={onFermer} aria-label="Fermer">✕</button>
        {envoye ? (
          <div className="modale-succes">
            <span className="modale-succes-icone">✅</span>
            <h3>Demande bien reçue, {form.nom} !</h3>
            <p>
              Nous revenons vers vous sous 24 h avec une offre adaptée à votre volume.
              Une question urgente ? Écrivez-nous au +509 4737 6200.
            </p>
            <button type="button" className="tarif-btn featured-btn" onClick={onFermer}>Fermer</button>
          </div>
        ) : (
          <>
            <h3 className="modale-titre">Parlons de votre projet</h3>
            <p className="modale-intro">
              Décrivez vos besoins en hébergement et noms de domaine.
              Nous construisons une offre à votre volume.
            </p>
            {erreur && <div className="modale-erreur">⚠️ {erreur}</div>}
            <div className="modale-champ">
              <label htmlFor="bp-nom">Nom complet *</label>
              <input id="bp-nom" name="nom" type="text" value={form.nom} onChange={changer} />
            </div>
            <div className="modale-champ">
              <label htmlFor="bp-email">Email *</label>
              <input id="bp-email" name="email" type="email" value={form.email} onChange={changer} />
            </div>
            <div className="modale-champ">
              <label htmlFor="bp-wa">WhatsApp</label>
              <input id="bp-wa" name="whatsapp" type="tel" value={form.whatsapp} onChange={changer} />
            </div>
            <div className="modale-champ">
              <label htmlFor="bp-nb">Combien de sites à héberger ?</label>
              <select id="bp-nb" name="nbSites" value={form.nbSites} onChange={changer}>
                <option>1 à 5</option>
                <option>6 à 15</option>
                <option>16 à 50</option>
                <option>Plus de 50</option>
              </select>
            </div>
            <div className="modale-champ">
              <label htmlFor="bp-besoin">Décrivez votre besoin *</label>
              <textarea
                id="bp-besoin" name="besoin" rows="4" value={form.besoin} onChange={changer}
                placeholder="Type de clients, volume prévu, domaines souhaités, échéance..."
              />
            </div>
            <button
              type="button" className="tarif-btn featured-btn"
              onClick={envoyer} disabled={envoi}
            >
              {envoi ? '⏳ Envoi en cours...' : 'Envoyer ma demande'}
            </button>
            <p className="modale-mention">
              Réponse sous 24 h. Vos informations restent confidentielles.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
function SegmentTarifs({ segment, onChoisir, style }) {
  const [modaleOuverte, setModaleOuverte] = useState(false);
  return (
    <div className="tarif-segment" style={style}>
      <div className="tarif-segment-header">
        <span className="tarif-segment-icon">{segment.icone}</span>
        <div>
          <h3 className="tarif-segment-titre">{segment.titre}</h3>
          <p className="tarif-segment-sous">{segment.sousTitre}</p>
        </div>
      </div>
      <div className="tarifs-grid">
        {segment.offres.map((offre, i) => (
          <Revele key={offre.nom} delai={i * 90}>
            <CarteTarif offre={offre} onChoisir={onChoisir} />
          </Revele>
        ))}
      </div>
      {segment.surMesure && (
        <Revele>
          <div className="tarif-surmesure">
            <div className="tarif-surmesure-gauche">
              <span className="tarif-surmesure-badge">{segment.surMesure.badge}</span>
              <h3>{segment.surMesure.nom}</h3>
              <p className="tarif-surmesure-accroche">{segment.surMesure.accroche}</p>
              <p className="tarif-surmesure-texte">{segment.surMesure.texte}</p>
            </div>
            <div className="tarif-surmesure-droite">
              <ul className="tarif-surmesure-liste">
                {segment.surMesure.points.map(p => <li key={p}>✅ {p}</li>)}
              </ul>
              <button
                type="button"
                className="tarif-btn featured-btn"
                onClick={() => setModaleOuverte(true)}
              >
                {segment.surMesure.cta}
              </button>
              <a
                className="tarif-btn tarif-btn-affilie"
                href={segment.surMesure.lienAffilie}
                target="_blank"
                rel="noopener sponsored"
              >
                {segment.surMesure.ctaAffilie}
              </a>
              <p className="tarif-surmesure-mention">{segment.surMesure.mentionAffilie}</p>
            </div>
          </div>
        </Revele>
      )}
      {modaleOuverte && <ModaleBesoin onFermer={() => setModaleOuverte(false)} />}
    </div>
  );
}
// ══════════════════════════════════════════════════════════════
// COMPOSANT PRINCIPAL
// ══════════════════════════════════════════════════════════════
function Accueil() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [formCanvas, setFormCanvas] = useState({ nom: '', email: '', telephone: '' });
  const [canvasTelecharge, setCanvasTelecharge] = useState(false);
  const [erreurCanvas, setErreurCanvas] = useState('');
  const [chargement, setChargement] = useState(false);
  // ── Navigation consciente de la connexion ──
  // Un utilisateur déjà connecté ne doit jamais repasser par /connexion
  // ══ v2.2 — Quota chargé en arrière-plan, sans jamais bloquer l'affichage ══
  const [quotaAtteint, setQuotaAtteint] = useState(false);

  useEffect(() => {
    let annule = false;
    if (!user?.id) { setQuotaAtteint(false); return; }

    const charger = async () => {
      try {
        const { ok, data } = await appelAPI('/api/mon-quota');
        if (annule || !ok || !data.succes) return;
        const q = data.quota;
        if (q && !q.illimite && q.restant !== undefined && q.restant <= 0) {
          setQuotaAtteint(true);
        }
      } catch (err) {
        // Silencieux : le wizard et le backend prendront le relais
      }
    };

    charger();
    return () => { annule = true; };
  }, [user]);

  // Routage : non connecté → connexion, quota atteint → tableau de bord
  const allerCreer = () => {
    if (!user) return navigate('/connexion');
    if (quotaAtteint) return navigate('/tableau-de-bord');
    navigate('/creer-mon-site');
  };

  const allerEspace = () => navigate(user ? '/tableau-de-bord' : '/connexion');

  // Fait defiler la page jusqu'au bloc de telechargement du Canvas
  const allerCanvas = () => {
    const bloc = document.getElementById('canvas-debutant');
    if (bloc) bloc.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  const handleCanvasChange = (e) => {
    setFormCanvas({ ...formCanvas, [e.target.name]: e.target.value });
  };
  const handleTelecharger = async () => {
    if (!formCanvas.nom || !formCanvas.email) {
      setErreurCanvas('Veuillez entrer votre nom et votre email.');
      return;
    }
    setErreurCanvas('');
    setChargement(true);
    try {
      await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          access_key: '1a0e5769-fe54-4c9c-a553-91070bf0e9d2',
          subject: '📥 Nouveau téléchargement Canvas — PEFEP Site',
          from_name: 'PEFEP Site',
          name: formCanvas.nom,
          email: formCanvas.email,
          telephone: formCanvas.telephone || 'Non fourni',
          message: `Nouveau téléchargement Canvas\nNom : ${formCanvas.nom}\nEmail : ${formCanvas.email}\nTéléphone : ${formCanvas.telephone || 'Non fourni'}`,
        }),
      });
      const lien = document.createElement('a');
      lien.href = 'https://drive.google.com/uc?export=download&id=1pLfuWkKtXmSajTFL7u6h3fjs57-_YFcH';
      lien.target = '_blank';
      lien.rel = 'noopener noreferrer';
      document.body.appendChild(lien);
      lien.click();
      document.body.removeChild(lien);
      setCanvasTelecharge(true);
      setChargement(false);
    } catch (err) {
      setErreurCanvas('Une erreur est survenue. Contactez-nous sur WhatsApp.');
      setChargement(false);
    }
  };
  return (
    <div className="accueil-container">
      <SEO {...SEO_PAGES.accueil} />
      <Navigation />
  
      {/* ══ HERO ══ */}
      <section className="hero-section">
        <div className="hero-content">
<img src={process.env.PUBLIC_URL + '/logo-pefep-site-blanc.png'} alt="PEFEP Site" className="hero-logo" />
          <div className="hero-badge">🇭🇹 La première plateforme haïtienne de création de site par IA</div>
          <h1 className="hero-titre">Créez votre site web professionnel en quelques minutes</h1>
          <p className="hero-sous-titre">
            Sans compétences techniques. Sans agence. Sans attendre des semaines.
            Répondez à quelques questions — l'intelligence artificielle fait le reste.
          </p>
          <div className="hero-buttons">
            <button type="button" className="btn-hero-primary" onClick={allerCreer}>
              {quotaAtteint
                ? '💳 Régler mon site en attente'
                : `🚀 ${user ? 'Créer mon site' : 'Créer mon site maintenant'}`}
            </button>
            <button type="button" className="btn-hero-secondary" onClick={allerEspace}>
              💻 {user ? 'Mon tableau de bord' : 'Espace développeur'}
            </button>
          </div>
          <button type="button" className="btn-hero-debutant" onClick={allerCanvas}>
            🔰 Vous êtes débutant ? Téléchargez notre guide gratuit
          </button>
          {/* ── CHIFFRES CLÉS ── */}
          <div className="hero-stats">
            {STATS.map((s, i) => (
              <div className="stat-carte" key={s.label} style={{ animationDelay: `${i * 130}ms` }}>
                <span className="stat-icone">{s.icone}</span>
                <span className="stat-num">
                  {s.valeur}{s.suffixe && <em>{s.suffixe}</em>}
                </span>
                <span className="stat-label">{s.label}</span>
                <span className="stat-detail">{s.detail}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* ══ COMMENT ÇA MARCHE ══ */}
      <section className="comment-section">
        <div className="section-container">
          <EnTeteSection
            badge="⚡ Simple &amp; Rapide"
            titre="Comment ça marche ?"
            sousTitre="3 étapes simples pour avoir votre site web professionnel en ligne."
          />
          <div className="etapes-grid etapes-grid-liee">
            {ETAPES.map((e, i) => (
              <Revele key={e.num} delai={i * 140}>
                <div className="etape-card">
                  <div className="etape-num">{e.num}</div>
                  <div className="etape-icon">{e.icone}</div>
                  <h3>{e.titre}</h3>
                  <p>{e.texte}</p>
                </div>
              </Revele>
            ))}
          </div>
        </div>
      </section>
      {/* ══ POURQUOI PEFEP Site ══ */}
      <section className="pourquoi-section">
        <div className="section-container">
          <EnTeteSection
            sombre
            badge="✨ Nos avantages"
            titre="Pourquoi choisir PEFEP Site ?"
            sousTitre="Six raisons concrètes qui font la différence pour les entrepreneurs haïtiens."
          />
          <div className="avantages-grid">
            {AVANTAGES.map((a, i) => (
              <Revele key={a.titre} delai={i * 80}>
                <div className={`avantage-card avantage-${a.teinte}`}>
                  <span className="avantage-icon">{a.icone}</span>
                  <h3>{a.titre}</h3>
                  <p>{a.texte}</p>
                </div>
              </Revele>
            ))}
          </div>
        </div>
      </section>
      {/* ══ CANVAS TÉLÉCHARGEABLE ══ */}
      <section className="canvas-section" id="canvas-debutant">
        <div className="section-container">
          <div className="canvas-card">
            <div className="canvas-gauche">
              <div className="section-badge">Guide Gratuit</div>
              <h2 className="canvas-titre">Vous êtes débutant ou vous ne savez pas à quoi vous attendre ?</h2>
              <p className="canvas-texte">
                Téléchargez notre <strong>Canvas de Préparation</strong> — le guide officiel PEFEP Site
                qui vous accompagne étape par étape avant de créer votre site. Préparez vos informations,
                vos photos et vos textes à l'avance pour un résultat encore plus professionnel.
              </p>
              <ul className="canvas-liste">
                <li>✅ 98 questions organisées par section</li>
                <li>✅ Conseils pour vos photos et visuels</li>
                <li>✅ Sections spécifiques pour 11 secteurs</li>
                <li>✅ Checklist complète avant de démarrer</li>
                <li>✅ 100% gratuit</li>
              </ul>
            </div>
            <div className="canvas-droite">
              <div className="canvas-form">
                <h3>Téléchargez votre guide gratuit</h3>
                {erreurCanvas && <div className="canvas-erreur">⚠️ {erreurCanvas}</div>}
                {canvasTelecharge ? (
                  <div className="canvas-succes">
                    ✅ Merci {formCanvas.nom} ! Votre guide est en cours de téléchargement.
                    Nous vous contacterons sur {formCanvas.email} pour le suivi.
                  </div>
                ) : (
                  <>
                    <div className="canvas-field">
                      <input
                        type="text" name="nom" placeholder="Votre nom complet *"
                        value={formCanvas.nom} onChange={handleCanvasChange}
                      />
                    </div>
                    <div className="canvas-field">
                      <input
                        type="email" name="email" placeholder="Votre adresse email *"
                        value={formCanvas.email} onChange={handleCanvasChange}
                      />
                    </div>
                    <div className="canvas-field">
                      <input
                        type="tel" name="telephone" placeholder="Votre numéro WhatsApp"
                        value={formCanvas.telephone} onChange={handleCanvasChange}
                      />
                    </div>
                    <button
                      type="button" className="canvas-btn"
                      onClick={handleTelecharger} disabled={chargement}
                    >
                      {chargement ? '⏳ Envoi en cours...' : '📥 Télécharger le guide gratuit'}
                    </button>
                    <p className="canvas-mention">
                      Vos informations restent confidentielles et ne seront jamais partagées.
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ══ SECTEURS ══ */}
      <section className="secteurs-section">
        <div className="section-container">
          <Revele>
            <header className="entete-section entete-vedette">
              <div className="section-badge section-badge-xl">🎯 Le cœur de la plateforme</div>
              <h2 className="section-titre section-titre-geant">
                <strong>11 secteurs</strong> couverts,<br />
                <span>chacun avec ses propres questions</span>
              </h2>
              <p className="section-sous-titre">
                Un restaurant n'a pas les mêmes besoins qu'une église ou qu'une ONG.
                PEFEP Site pose les bonnes questions pour <strong>votre</strong> métier.
              </p>
              <span className="entete-trait" />
            </header>
          </Revele>
          <div className="secteurs-accueil-grid">
            {SECTEURS.map((s, i) => (
              <Revele key={s.label} delai={i * 45}>
                <button type="button" className="secteur-accueil-card" onClick={allerCreer}>
                  <span className="secteur-accueil-icon">{s.icone}</span>
                  <span className="secteur-accueil-label">{s.label}</span>
                </button>
              </Revele>
            ))}
            <Revele delai={SECTEURS.length * 45}>
              <button
                type="button"
                className="secteur-accueil-card secteur-accueil-autre"
                onClick={() => navigate('/contact')}
              >
                <span className="secteur-accueil-icon">➕</span>
                <span className="secteur-accueil-label">Votre secteur ?<br /><em>Parlons-en</em></span>
              </button>
            </Revele>
          </div>
          <div className="secteurs-cta">
            <button type="button" className="btn-hero-primary" onClick={allerCreer}>
              Créer mon site maintenant →
            </button>
          </div>
        </div>
      </section>
      {/* ══ TARIFS ══ */}
      <section className="tarifs-section">
        <div className="section-container">
          <EnTeteSection
            badge="💳 Tarifs clairs &amp; transparents"
            titre="Des prix accessibles pour tous"
            sousTitre="Pas de surprise. Pas d'abonnement caché. Payez uniquement ce que vous utilisez."
          />
          <SegmentTarifs segment={TARIFS_CLIENT} onChoisir={allerCreer} />
          <SegmentTarifs segment={TARIFS_DEV} onChoisir={allerCreer} style={{ marginTop: 50 }} />
          <p className="tarifs-paiement">
            💳 Paiement en ligne sécurisé par MonCash — MonCash International accepté pour la diaspora
          </p>
        </div>
      </section>
      <PiedDePage />

      <BoutonWhatsAppFlottant />
    </div>
  );
}

// ══════════════════════════════════════════════════════════════
// BOUTON FLOTTANT WHATSAPP
// ══════════════════════════════════════════════════════════════
// Bouton vert fixe en bas a droite. Au clic, un petit formulaire
// simple (nom, numero, email, interet) s'ouvre. La personne accepte
// d'etre recontactee par PEFEP Site pour le suivi. A l'envoi, un
// message WhatsApp pre-rempli est ouvert vers le numero de PEFEP.
// ══════════════════════════════════════════════════════════════

const WHATSAPP_PEFEP_ACCUEIL = '50947376200';

function BoutonWhatsAppFlottant() {
  const [ouvert, setOuvert] = React.useState(false);
  const [envoye, setEnvoye] = React.useState(false);
  const [erreur, setErreur] = React.useState('');
  const [form, setForm] = React.useState({
    nom: '', numero: '', email: '', interet: '', accord: false,
  });

  const changer = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === 'checkbox' ? checked : value });
  };

  const envoyer = () => {
    if (!form.nom || !form.numero) {
      setErreur('Merci d\'indiquer votre nom et votre numéro.');
      return;
    }
    if (!form.accord) {
      setErreur('Merci d\'accepter d\'être recontacté pour le suivi.');
      return;
    }
    setErreur('');

    const lignes = [
      'Bonjour PEFEP Site !',
      '',
      'Nom : ' + form.nom,
      'Numéro : ' + form.numero,
    ];
    if (form.email) lignes.push('Email : ' + form.email);
    if (form.interet) lignes.push('Mon intérêt : ' + form.interet);
    lignes.push('');
    lignes.push('J\'accepte d\'être recontacté pour le suivi.');

    const message = encodeURIComponent(lignes.join('\n'));
    window.open(
      'https://wa.me/' + WHATSAPP_PEFEP_ACCUEIL + '?text=' + message,
      '_blank',
      'noopener,noreferrer'
    );
    setEnvoye(true);
  };

  return (
    <div>
      <button
        type="button"
        className="wa-flottant-btn"
        onClick={() => setOuvert(true)}
        aria-label="Nous contacter sur WhatsApp"
      >
        💬
      </button>

      {ouvert && (
        <div className="wa-flottant-voile" onClick={() => setOuvert(false)}>
          <div className="wa-flottant-fenetre" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="wa-flottant-fermer"
              onClick={() => setOuvert(false)}
              aria-label="Fermer"
            >
              ×
            </button>

            <div className="wa-flottant-entete">
              <div className="wa-flottant-titre">Discutons sur WhatsApp</div>
              <p className="wa-flottant-sous">
                Laissez-nous vos coordonnées, notre équipe vous recontacte rapidement.
              </p>
            </div>

            {envoye ? (
              <div className="wa-flottant-succes">
                ✅ Merci {form.nom} ! WhatsApp s'est ouvert avec votre message.
                Envoyez-le pour finaliser — nous vous répondrons vite.
              </div>
            ) : (
              <div className="wa-flottant-corps">
                <input
                  className="wa-flottant-champ"
                  type="text" name="nom" placeholder="Votre nom *"
                  value={form.nom} onChange={changer}
                />
                <input
                  className="wa-flottant-champ"
                  type="tel" name="numero" placeholder="Votre numéro WhatsApp *"
                  value={form.numero} onChange={changer}
                />
                <input
                  className="wa-flottant-champ"
                  type="email" name="email" placeholder="Votre email (facultatif)"
                  value={form.email} onChange={changer}
                />
                <textarea
                  className="wa-flottant-champ"
                  name="interet" rows={3}
                  placeholder="Votre message ou ce qui vous intéresse"
                  value={form.interet} onChange={changer}
                />

                <label className="wa-flottant-accord">
                  <input
                    type="checkbox" name="accord"
                    checked={form.accord} onChange={changer}
                  />
                  <span>J'accepte d'être recontacté par PEFEP Site pour le suivi.</span>
                </label>

                {erreur && <div className="wa-flottant-erreur">⚠️ {erreur}</div>}

                <button type="button" className="wa-flottant-envoyer" onClick={envoyer}>
                  Envoyer sur WhatsApp
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Accueil;